export default __webpack_public_path__ + "static/helveticaneue-14cc85b1652bbe1956b0502aaa3a1f4e.woff";